export const DESCRIPTION_LANGUAGE_INDEX = 0;

export const VIEW_1 = {
    VEHICLE: {
        HIGH_PRICE: 'highPrice',
        HIGH_PRICE_INDEX: 0,
        URL_EXTERIOR_COLOUR: 7,
        EXTERIOR_COLOUR_STATUS: 9,

        REBATE: 'rebate',
        REBATE_INDEX: 0,
        REBATE_RETAIL: 6,

        HIGH_REBATE: 'highRebate',
        HIGH_REBATE_INDEX: 0,
        HIGH_REBATE_RETAIL: 6,
        HIGH_REBATE_PURCHASE_METHOD: 8,
        HIGH_REBATE_REBATES_TAXES: 9,

        PRICE: 'price',
        PRICE_INDEX: 0,
        PRICE_YEAR: 0,
        PRICE_MODEL_TRIM_CODE: 3,
        PRICE_CONFIGURATION_ID: 4,
        PRICE_RETAIL: 6,
        PRICE_AMOUNTS: 9,
        PRICE_DISCLAIMER: 10,

        LEASE: 'lease',
        LEASE_INDEX: 0,
        LEASE_YEAR: 0,
        LEASE_MODEL_TRIM_CODE: 3,
        LEASE_CONFIGURATION_ID: 4,
        LEASE_TERMS: 6,
        LEASE_DISCLAIMER: 18,

        FINANCE: 'finance',
        FINANCE_INDEX: 0,
        FINANCE_YEAR: 0,
        FINANCE_MODEL_TRIM_CODE: 3,
        FINANCE_CONFIGURATION_ID: 4,
        FINANCE_TERMS: 6,
        FINANCE_DISCLAIMER: 12,
    },

    COLOUR_IMAGE: {
        PHOTO_1: 0,
        PHOTO_2: 1,
        PHOTO_3: 2,
    },

    FINANCE: {
        PAYMENT_FREQUENCY: 0,
        BASE_PAYMENT: 1,
        FEES_PAYMENT: 2,
        DUTIES_PAYMENT: 3,
        PAYMENT_TAXES: 4,
        FINANCE_FACTOR: 5,
        BALLOON_FACTOR: 6,
    },

    PRICE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1,
        MODEL_PRICE: 2,
        INCLUSIONS: 3,
        EXCLUSIONS: 4,
    },

    FINANCE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1,
    },

    PRICING: {
        BASE_RETAIL: 0,
        FREIGHT_PDI: 1,
        TAXES_DUTIES: 2,
    },
};

export const VIEW_2_1 = {
    VEHICLE: {
        MODEL_YEARS: 0,

        MODEL_YEAR: {
            BIT_FIELD: 0,
            YEAR: 1,
            FEATURES: 2,
            CABS: 3,
            DRIVES: 4,
            TRANSMISSIONS: 5,
            BOXES: 6,
            TRIMS: 7,
        },

        FEATURES: {
            BIT_FIELD: 0,
            LIST: 1,

            FEATURE: {
                CODE: 0,
                TYPE: 1,
                KEY_ORDER: 2,
                IS_STANDARD: 3,
                DATA_TYPE_ID: 4,
                TYPE_ID: 5,
                DESCRIPTION: 6,
                TYPE_IDS: 7,
                TYPE_ICONS: 8,
                COLOUR_FEATURES: 9,

                ICON: {
                    KEY_ORDER: 0,
                    VALUE: 1,
                    CODE: 2,
                    DESCRIPTION: 3,
                },
            },
        },

        CAB: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2,
        },

        DRIVE: {
            BIT_FIELD: 0,
            ID_CODE: 2,
            DESCRIPTION: 1,
            CODE: 3,
            LONG_DESCRIPTION: 4,
        },

        TRANSMISSION: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2,
        },

        BOX: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2,
        },

        TRIM: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2,
            CONFIGURATIONS: 3,
            EXTENSION_DESCRIPTION: 4,
            EXTENSION_CODE: 5,
            HAS_OPTIONS: 6,

            CONFIGURATION: {
                BIT_FIELD: 0,
                TRIM_CODE: 1,
                TRIM_RANK: 2,
                ID: 3,
                RANK: 4,
                DESCRIPTION: 5,
                SEATING: 6,
                FUEL_CONSUMPTION: 7,
                ENGINE: 8,
                TRANSMISSION: 9,
                PACKAGE_CODE: 10,
                PACKAGE: 11,
                OPTION_CODES: 12,
                URL_EXTERIOR_COLOUR: 13,
                URL_INTERIOR_TRIM: 14,
                PRICING: 15,
                FINANCE: 16,
                LEASE: 17,
                CAR_ID: 18,
                VEH_ID: 19,
            },

            ENGINE: {
                FUEL: 0,
                CYLINDERS: 1,
                DISPLACEMENT: 2,
                IS_TURBO: 3,
                HP: 4,
                HP_RPM: 5,
                TORQUE: 6,
                TORQUE_RPM: 7,
            },

            TRANSMISSION: {
                TYPE_CODE: 0,
                TYPE: 1,
                SPEEDS: 2,
                IS_CVT: 3,
                DESCRIPTION: 4,
            },

            COLOUR_IMAGE: {
                CODE: 0,
                TILE: 1,
                PHOTO_1: 2,
                PHOTO_2: 3,
                PHOTO_3: 4,
                PRICING: 5,

                AMOUNTS: {
                    RETAIL: 0,
                    RESIDUAL_RETAIL: 1,
                },
            },

            PRICING: {
                RETAIL: 0,
                REBATE: 1,
            },
        },

        LEASE_TERMS: 0,

        FINANCE_TERMS: 0,
    },

    FINANCE: {
        APR: 0,
        TERM: 1,
        DISCOUNT: 3,
        REBATE: 4,
        REBATE_AT_DELIVERY: 5,
        CASH_DOWN: 6,
        PAYMENT_FREQUENCIES: 7,

        PAYMENT_FREQUENCY: 0,
        PAYMENT: 1,
        PAYMENT_TAXES: 2,
        FINANCE_FACTOR: 3,
        BALLOON_FACTOR: 4,
    },

    DATA_TYPES: {
        FEATURE: 1,
        TAX_AND_DUTY: 2,
        FEE: 3,
        PROTECTION: 4,
        REBATE: 5,
        FEATURE_TYPE_MECHANICAL: 1,
        FEATURE_TYPE_EXTERIOR: 2,
        FEATURE_TYPE_COMMUNICATION: 3,
        FEATURE_TYPE_INTERIOR: 4,
        FEATURE_TYPE_SAFETY: 5,
        FEATURE_TYPE_MODEL_TRIM: 50,
        FEATURE_TYPE_PACKAGE: 51,
        FEATURE_TYPE_ENGINE: 52,
        FEATURE_TYPE_TRANSMISSION: 53,
        FEATURE_TYPE_EXTERIOR_COLOUR: 54,
        FEATURE_TYPE_INTERIOR_TRIM: 55,
        TAX_AND_DUTY_TYPE_AIR: 1,
        TAX_AND_DUTY_TYPE_WEIGHT: 2,
        TAX_AND_DUTY_TYPE_BATTERY: 3,
        TAX_AND_DUTY_TYPE_TIRE: 4,
        TAX_AND_DUTY_TYPE_ENVIRONMENTAL: 5,
        TAX_AND_DUTY_TYPE_LICENCE: 6,
        TAX_AND_DUTY_TYPE_RECOVERY: 7,
        TAX_AND_DUTY_TYPE_LEVY: 8,
        FEE_TYPE_FREIGHT: 1,
        FEE_TYPE_PREPARATION: 2,
        FEE_TYPE_MARKETING: 3,
        FEE_TYPE_REGISTRATION: 4,
        FEE_TYPE_ADMINISTRATION_DEALER: 5,
        FEE_TYPE_DOCUMENT: 6,
        FEE_TYPE_ACQUISITION: 7,
        FEE_TYPE_ADMINISTRATION_CREDITOR: 8,
        FEE_TYPE_RECOVERY: 9,
        FEE_TYPE_RECYCLING: 10,
        FEE_TYPE_SECURITY_DEPOSIT: 11,
        FEE_TYPE_LEASE_BUY_BACK: 12,
    },

    DEFAULT_ICON: 'E917',
};

export default {
    DESCRIPTION_LANGUAGE_INDEX,
    VIEW_1,
    VIEW_2_1,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/constants/apiDataConversionConstants.js